import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../@types/filter";
import { InternalService } from "../../@types/internal-service";
import { apisiseci } from "../api";
import { useDefaultSearchParams } from "../../hooks/useSearchParams";
import { AxiosError } from "axios";
import { AttendanceLocal } from "../../@types/attendance-local";
import { AttendanceLocalDepartmentGuiche } from "../../@types/attendance-local-department-guiche";
import { AttendanceLocalDepartment } from "../../@types/attendance-local-department";

type Props = DefaultFilter & {
    unidade?: AttendanceLocal["slug_unidade"];
    fila?: boolean;
    setor_unidade?: AttendanceLocalDepartment["id"];
    guiche_id?: AttendanceLocalDepartmentGuiche["id"];
};

export function useInternalServiceList(params?: Props) {
    const apiKey = (window as any)._env_.REACT_APP_API_SISECI_KEY ?? "";
    const defaultParams = useDefaultSearchParams();
    params = { ...defaultParams, ...params };

    return useQuery<Array<InternalService>, AxiosError<{ detail: string }>>({
        enabled: !!apiKey,
        queryKey: ['internal-service', 'list', params],
        queryFn: async () => {
            const response = await apisiseci.get<Array<InternalService>>(
                "/cms/serv_internos/",
                { headers: { Authorization: `${apiKey}` }, params }
            );
            return response.data;
        },
    });
}
